export default "__VITE_ASSET__XKuU$lLY__"